<script>
import RaSelectButton from "@/components/ra-select-button.vue";
import {
  customerDetail,
  increasePoints,
  resetAvatar,
  searchUsers,
  sendVerificationCode,
  updateInviter, updateUserPhone
} from "@/api/customer";
import raSimpleDialog from "@/components/ra-simple-dialog.vue";
import debounce from '@/utils'
import {formatterSize} from '@/utils'

export default {
  components: {RaSelectButton, raSimpleDialog},
  props: {
    detail: {}
  },
  data() {
    return {
      customerDetailDialog: false,
      customerActiveNames: '',
      detailLoading: false,
      baseURL: process.env.VUE_APP_BASE_URL,
      baseInfo: {},
      customerDetailForm: {
      },
      reverse: false,
      isBold: 'usable',
      phoneForm: {
        phone: '',
        code: ''
      },
      phoneConfirmBtnText: 'Next',
      points: [],
      coupons: [],
      inviteInfo: {
        inviter: {},
        invitedFriends: [],
      },
      phoneStep: 'first',
      countDown: 60,
      interval: null,
      inviteForm: {
        inviterId: '',
      },
      userLoading: false,
      userOptions: [],
      debounceFunc: debounce(this.getUser, 300),
      inviteTitle: '',
      inviteType: '',
      friend: {},
      point_total:'',
      promotions: {
        expired: [],
        usable: [],
        used: []
      },
      pointForm:{
        point:'',
      },
    }
  },
  methods: {
    toggleBold(key) {
      this.isBold = key
    },
    remoteMethod (query) {
      this.debounceFunc(query)
    },
    getUser(query) {
      searchUsers({ search_key: 'name', search_value: query }).then(res => {
        if (res.code === 200) {
          this.userOptions = res.data.list;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    getDetail() {
      this.detailLoading = true;
      customerDetail({id: this.detail.id}).then((res) => {
        this.detailLoading = false;
        if (res.code === 200) {
          this.baseInfo = res.data.base_info;
          console.log(this.baseInfo,'baseInfo')
          this.points = res.data.points_info.history;
          this.point_total = res.data.points_info.total
          this.promotions = res.data.coupons.list;
          this.inviteInfo = res.data.invite_info;
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    resetAvatarHandle() {
      this.$refs.avatarDialog.dialogVisible = true
    },
    avatarSubmit() {
      resetAvatar({id: this.baseInfo.id}).then(res => {
        if (res.code === 200) {
          this.$message.success('successfully reset');
          this.$refs.avatarDialog.dialogVisible = false
          this.updateData()
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    updateData() {
      this.getDetail()
      this.$emit('updateList')
    },
    modifyPhone() {
      this.$refs.phoneDialog.dialogVisible = true;
      this.phoneStep = 'first';
      this.countDown = 60;
      this.$nextTick(() => {
        this.$refs.phoneForm.clearValidate()
      })
    },
    sendVerificationCodeHandle() {
      return sendVerificationCode({
        id: this.detail.id,
        phone: this.phoneForm.phone,
        phone_code: '1'
      }).then(res => {
          return res; // 返回结果给调用者
      });
    },
    handleInterval() {
      if (this.countDown !== 60) return
      this.interval = setInterval(() => {
        if (this.countDown === 0) {
          clearInterval(this.interval);
        } else {
          this.countDown -= 1
        }
      }, 1000)
    },
    phoneHandle() {
      if (this.phoneStep === 'first') {
        this.$refs.phoneForm.validate(valid => {
          if (valid) {
            this.$nextTick(() => {
              this.$refs.phoneForm.clearValidate()
            })
            this.sendVerificationCodeHandle().then(res => {
              if (res.code === 200) {
                // 只有在返回 200 时才执行以下代码
                this.phoneStep = 'second';
                this.phoneConfirmBtnText = 'Submit';
                this.countDown = 60;
                clearInterval(this.interval);
                this.handleInterval();
                this.$message({
                  type:'success',
                  message:res.msg
                })
              }else{
                this.$message({
                  type:'error',
                  message:res.msg
                })
              }
            });
          }
        })
      }
      if (this.phoneStep === 'second') {
        this.$refs.phoneForm.validate(valid => {
          if (valid) {
            updateUserPhone({
              id:this.detail.id,
              phone:this.phoneForm.phone,
              phone_code:'1',
              code:this.phoneForm.code,
            }).then(res=>{
              if (res.code == 200){
                this.phoneCancel()
                this.customerDetailDialog = false
                this.$refs.phoneDialog.dialogVisible = false;
                this.updateData()
                this.$message({
                  message:res.msg,
                  type:"success"
                })
              }else{
                this.$message({
                  type:'error',
                  message:res.msg
                })
              }
            })
          }
        })
      }
    },
    phoneCancel() {
      this.phoneConfirmBtnText = 'Next'
      this.phoneForm.code = ''
      this.phoneForm.phone = ''
    },
    resendHandle() {
      this.countDown = 60
      this.handleInterval()
      this.sendVerificationCodeHandle().then(res => {
        if (res.code === 200) {
          // 只有在返回 200 时才执行以下代码
          this.phoneStep = 'second';
          this.phoneConfirmBtnText = 'Submit';
          this.countDown = 60;
          clearInterval(this.interval);
          this.handleInterval();
          this.$message({
            type:'success',
            message:res.msg
          })
        }else{
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      });
    },
    formatterSize,
    modifyInviter(type, friend) {
      if (type === '1') { this.inviteTitle = 'Who invited this user to join Rapidi Plus:' }
      if (type === '2') { this.inviteTitle = 'Friend invited by' }
      this.inviteType = type
      this.friend = friend
      this.$refs.inviter.dialogVisible = true
    },
    cancelInviter() {
      this.userOptions = []
      this.$refs.inviteForm.resetFields()
      this.$nextTick(() => {
        this.$refs.inviteForm.clearValidate()
      })
    },
    resetInviter() {
      console.log(this.friend,this.inviteForm.inviterId,this.inviteType,this.detail.id , this.baseInfo.id,'this.inviteForm.inviterId')
      this.$refs.inviteForm.validate(valid => {
        if (valid) {
          const params = {
            type: this.inviteType,
            user_id: this.inviteType === '1' ? this.detail.id : this.baseInfo.id,
            old_inviter_id:this.friend.id,
            new_inviter_id: this.inviteForm.inviterId
          }
          updateInviter(params).then(res => {
            if (res.code === 200) {
              this.$message.success('update successfully');
              this.updateData()
              this.userOptions = []
              this.$refs.inviter.dialogVisible = false
              this.cancelInviter()
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    changeDropHandle(val){
      this.$emit("openDeleteHandle",val)
    },
    pointSubmit(){
      this.$refs.pointForm.validate(valid => {
        if (valid) {
          increasePoints({
            user_id:this.detail.id,
            points:this.pointForm.point,
            remark:"",
          }).then(res=>{
            if (res.code == 200){
              this.customerDetailDialog = false
              this.$refs.pointDialog.dialogVisible = false
              this.getDetail()
              this.$emit('updateList')
              this.pointForm.point = ''
              this.$message({
                message:res.msg,
                type:'success'
              })
            }else {
              this.$message({
                message:res.msg,
                type:'error'
              })
            }
          })
        }
      })
    },
    openPointHandle(){
     this.$refs.pointDialog.dialogVisible = true
    },
  },
  watch: {
    customerDetailDialog(val) {
      if (val) {
        this.getDetail()
      }
    }
  }
}
</script>

<template>
  <div>
    <el-dialog
        :close-on-click-modal="false"
        custom-class="right"
        :title="detail.name"
        :visible.sync="customerDetailDialog"
        width="540px">
      <div class="mt-4">
        <el-tabs v-model="customerActiveNames" stretch>
          <el-tab-pane label="Profile" name="name" class="profile">
            <el-scrollbar class="h-[calc(100vh-224px)] mt-4" v-loading="detailLoading">
              <el-form label-position="right" label-width="150px" :model="customerDetailForm" v-cloak>
                <el-form-item label="Avatar: ">
                  <div class="flex justify-between items-center">
                    <img class="w-10 h-10 rounded-full object-cover" :src="baseURL + baseInfo.avatar" alt=""/>
                    <span class="underline cursor-pointer border-1 border-solid" @click="resetAvatarHandle">Reset</span>
                  </div>
                </el-form-item>
                <el-form-item label="UID:">{{baseInfo.uid}}</el-form-item>
                <el-form-item label="Cellphone No.:">
                  <div class="flex justify-between">
                    <div>+{{baseInfo.phone_code}} {{baseInfo.phone}}</div>
                    <div class="h-10" style="cursor: pointer;border-bottom: 1px solid" @click="modifyPhone">Modify</div>
                  </div>
                </el-form-item>
                <el-form-item label="Created at:">{{ baseInfo.created_at }}</el-form-item>
                <el-form-item label="Last device OS:">{{ baseInfo.last_device_os }}</el-form-item>
              </el-form>
            </el-scrollbar>
            <div>
              <div class="text-right">
                <ra-select-button :active_mes="baseInfo.is_active == 1 ? 'Deactivate' :'Activate'"
                                  @changeDropHandle="changeDropHandle"></ra-select-button>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Points" name="points">
            <el-scrollbar class="mt-4 h-[calc(100vh-244px)]">
              <div class="mb-4 pb-4" style="border-bottom: 1px solid #E0E0E0">
                Points: {{point_total}}
              </div>
              <div v-if="points.length > 0">
                <el-timeline :reverse="reverse">
                  <el-timeline-item
                      v-for="(activity, index) in points"
                      :key="index"
                      :color="activity.color"
                      placement="top"
                      :timestamp="activity.description + ' ' + activity.type">
                    <div class="flex justify-between">
                      <div>{{ activity.created_at }}</div>
                      <div style="color: #1F2D42">{{ activity.points }}</div>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
              <div  v-else  class="grid place-items-center h-[calc(100vh-300px)]" >
                <div class=" p-4" style="color: #CCCCCC;">
                  No data
                </div>
              </div>
            </el-scrollbar>
            <div class="text-right pt-4" style="border-top: 1px solid #E0E0E0">
              <el-button type="primary" round class="btn-custom-red" @click="openPointHandle">Add points</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="Coupon" name="coupon">
            <el-scrollbar style="height: calc(100vh - 200px)">
              <div class="mt-4 mb-4 pb-4 flex gap-2" style="border-bottom: 1px solid #E0E0E0; cursor: pointer">
                <span @click="toggleBold('usable')" :class="{ bold: isBold === 'usable' }">Usable</span>
                <div class="w-0.5 h-3 mr-2 ml-2  mt-1" style="background-color: #E0E0E0"></div>
                <span @click="toggleBold('expired')" :class="{ bold: isBold === 'expired' }">Expired</span>
                <div class="w-0.5 h-3 mr-2 ml-2 mt-1" style="background-color: #E0E0E0"></div>
                <span @click="toggleBold('used')" :class="{ bold: isBold === 'used' }">Used</span>
              </div>
              <div>
                <div v-if="promotions[isBold].length > 0">
                  <div v-for="promotion in promotions[isBold]" :key="promotion.id" class="promotion-card">
                    <div v-if="isBold != 'usable'" class="right_title" :class="isBold == 'used' ? 'black_box':'' ">
                      {{isBold}}
                    </div>
                    <div class="flex justify-between">
                      <div>
                        <h3 style="color: #1F2D42;">{{ promotion.title }}</h3>
                      </div>
                      <!--                    <div class="expired_box" v-if="isBold !== 'usable'"-->
                      <!--                         :style="{ backgroundColor: isBold === 'used' ? '#000' : '' }">-->
                      <!--                      Expired-->
                      <!--                    </div>-->
                    </div>
                    <!--                  <span class="expired">{{ promotion.status }}</span>-->
                    <!--                  <p v-if="promotion.type === 1">Rate: {{'$' + promotion.rate}}</p>-->
                    <!--                  todo:这记得加一下 Flate rate-->
                    <p> <span v-if="promotion.discount.includes('off')">Percentage:</span>  <span v-else>Flate rate:</span>  {{ promotion.discount }}</p>
                    <p>Spend threshold: {{ promotion.spend_threshold }}</p>
                    <p>Deadline: {{ promotion.deadline }}</p>
                    <p>Valid sizes: {{ formatterSize(promotion.valid_sizes) }}</p>
                    <p>Received time: {{ promotion.received_at }}</p>
                  </div>
                </div>
                <div  v-else  class="grid place-items-center h-[calc(100vh-270px)]" >
                  <div class=" p-4" style="color: #CCCCCC;">
                    No data
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane label="Invited friends" name="invited_friends">
            <el-scrollbar style="height: calc(100vh - 200px)">
              <div class="space-y-6 mt-4" v-cloak>
                <div class=" text-base">Who invited this user to join Rapidi Plus:</div>
                  <div class="flex justify-between items-center" v-if="inviteInfo.inviter">
                    <div class="flex items-center">
                      <img :src="baseURL + inviteInfo.inviter?.avatar" class="w-10 h-10 rounded-full object-cover mr-4">
                      <span class="mr-4">{{inviteInfo.inviter?.name}}</span>
                    </div>
                    <span class="underline cursor-pointer" @click="modifyInviter('1',inviteInfo.inviter)">Modify</span>
                  </div>
                <div v-else class=" p-4" style="color: #CCCCCC;">
                  No data
                </div>

                <div class="text-base">Friends invited by this user</div>
                <div  v-if="inviteInfo.invited_friends?.length > 0">
                  <div v-for="friend in inviteInfo.invited_friends" :key="friend.id" class="flex items-center justify-between">
                    <div class="flex items-center">
                      <div class="w-10 h-10 rounded-full overflow-hidden mr-4">
                        <img :src="baseURL + friend.avatar" class="w-full h-full object-cover">
                      </div>
                      <div>
                        <span class="mr-4">{{ friend.name }}</span>
                      </div>
                    </div>
                    <span class="underline cursor-pointer" @click="modifyInviter('2', friend)">Modify</span>
                  </div>
                </div>
                <div v-else class=" p-4" style="color: #CCCCCC;">
                  No data
                </div>

              </div>
            </el-scrollbar>
          </el-tab-pane>
        </el-tabs>
      </div>
      <ra-simple-dialog
          title="Modify the user's cellphone No."
          cancelBtnText="Cancel"
          :confirmBtnText="phoneConfirmBtnText"
          ref="phoneDialog"
          :append-to-body="true"
          @cancel="phoneCancel"
          @confirmSubmit="phoneHandle">
        <template v-slot:default>
          <el-form label-position="top" :model="phoneForm" class="mt-[-16px]" ref="phoneForm" :show-message="false" status-icon>
            <el-form-item label="Phone number (Used to log in)" prop="phone" required  v-if="phoneStep === 'first'">
              <el-input v-model="phoneForm.phone" placeholder="Input the user's phone number" key="first">
                <template slot="prepend">+ 1</template>
              </el-input>
            </el-form-item>
            <el-form-item label="Verification number" prop="code" required  v-if="phoneStep === 'second'">
              <el-input v-model="phoneForm.code" placeholder="Input the verification number" key="second"></el-input>
            </el-form-item>
          </el-form>
        </template>
        <template v-slot:thirdBtn v-if="phoneStep === 'second'">
          <el-button key="code" :disabled="!!countDown" @click="resendHandle" plain class="w-[80px] border-black text-black">{{countDown === 0 ? 'Resend' : countDown + 's'}}</el-button>
        </template>
      </ra-simple-dialog>
      <ra-simple-dialog
          title="Reset this user's avatar"
          cancelBtnText="No"
          confirm-btn-text="Yes"
          ref="avatarDialog"
          :append-to-body="true"
          @confirmSubmit="avatarSubmit"
      >
        <span>Will you reset this user's avatar?</span>
      </ra-simple-dialog>
      <ra-simple-dialog
          :title="inviteTitle"
          cancelBtnText="No"
          confirm-btn-text="Yes"
          ref="inviter"
          :append-to-body="true"
          @confirmSubmit="resetInviter"
          @cancel="cancelInviter"
      >
        <el-form :show-message="false" status-icon :model="inviteForm" ref="inviteForm">
          <el-form-item required prop="inviterId">
            <el-select
                v-model="inviteForm.inviterId"
                filterable
                remote
                clearable
                reserve-keyword
                placeholder="Input customer's name"
                :remote-method="remoteMethod"
                :loading="userLoading">
              <el-option
                  v-for="item in userOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                <img class="rounded-full object-cover w-[20px] h-[20px]" :src="baseURL + item.avatar" />
                <span class="text-black pl-2 text-[14px] font-normal">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </ra-simple-dialog>

      <ra-simple-dialog
        title="Add points"
        cancelBtnText="Cancel"
        confirm-btn-text="Submit"
        ref="pointDialog"
        :append-to-body="true"
        @confirmSubmit="pointSubmit"
      >
        <div class="pt-4">
          <el-form label-position="top" :model="pointForm" class="mt-[-16px]" ref="pointForm" :show-message="false" status-icon>
            <el-form-item label="" prop="point" required>
              <el-input v-model="pointForm.point" placeholder="Input points to be added for this user"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </ra-simple-dialog>

    </el-dialog>
  </div>
</template>

<style scoped lang="less">
/deep/ .el-tabs__item {
  padding: 0 !important;
}

/deep/ .el-scrollbar__bar.is-horizontal {
  height: 0 !important;
}

.bold {
  font-weight: bold;
}
.profile{
  /deep/ .el-form-item__content {
    line-height: 52px !important;
  }
}
.promotion-card {
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  margin-bottom: 16px;
  padding: 16px;
  font-family: SFPro, SFPro;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  position: relative;
  .expired_box {
    background: #CCCCCC;
    border-radius: 20px;
    padding: 2px 8px;
    color: #fff;
  }
  .black_box{
    background: #000000 !important;
  }
  .right_title{
    position: absolute;
    top: 20px;
    right: 16px;
    padding: 2px 8px;
    background: #CCCCCC;
    border-radius: 11px;
    font-weight: 500;
    font-size: 12px;
    color: #FFFFFF;
    line-height: 18px;
    text-align: center;
    font-style: normal;
  }
}
/deep/ .el-button.is-disabled.is-plain{
  border: 1px solid #000000;
  background: #FFFFFF;
  color: #CCC !important;
}
/deep/ .el-button.is-plain.is-disabled:hover {
  border: 1px solid #000000;
  background: #FFFFFF;
  color: #CCCCCC !important;
}
/deep/ .el-button.is-plain:hover {
  color: #000000 !important;
  background: #FFFFFF !important;
}
</style>
